"use client";

import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useState } from "react";
import ProgressBar from "./ProgressBar";

interface IProps {
  paymentPolicy?: string;
  cancellationPolicy?: string;
  termsAndConditions?: string;
}

const CancellationPolicy: React.FC<IProps> = ({
  paymentPolicy,
  cancellationPolicy,
  termsAndConditions,
}) => {
  const [open, setOpen] = useState(false);

  const cancellationSteps = [
    { label: "Within 15–30 days", note: "30% non refundable" },
    { label: "Within 10–15 days", note: "75% non refundable" },
    { label: "Within 10 days", note: "100% non refundable" },
  ];

  const paymentSteps = [
    {
      label: "Within 45–30 days",
      note: "75% of total cost or non refundable component",
    },
    { label: "Within 30 days", note: "100% of total cost" },
  ];

  return (
    <section className="px-7">
      {/* Toggle Button */}
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center justify-between w-full py-2 cursor-pointer border-0 bg-transparent"
      >
        <span className="typography-large-body-regular text-grey-500 px-2">
          Cancellation policy
        </span>
        {open ? (
          <ChevronUp className="transition-transform duration-300" />
        ) : (
          <ChevronDown className="transition-transform duration-300" />
        )}
      </button>

      {open && (
        <div id="cancellation-content" role="region" className="mt-4">
          {/* Cancellation Policy */}
          <h3 className="typography-sub-h1-regular font-medium text-grey-800 mb-5">
            Cancellation policy (Per person)
          </h3>

          <div className="flex flex-row gap-3 lg:hidden">
            <div className="flex flex-col sm:flex-row md:flex-col gap-6 items-start">
              <ProgressBar count={cancellationSteps.length} />
            </div>

            <div className="flex flex-col sm:flex-row md:flex-col gap-6 items-start pt-10">
              <div className="flex-1 flex flex-col gap-10">
                {cancellationSteps.map((step) => (
                  <div key={step.label}>
                    <div className="typography-extra-large-body font-medium text-grey-800">
                      {step.label}
                    </div>
                    <p className="typography-large-body-light text-grey-500 mt-1">
                      {step.note}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="hidden lg:block ">
            <ProgressBar count={cancellationSteps.length} />

            <div className="flex-1 flex flex-row justify-between">
              {cancellationSteps.map((step) => (
                <div key={step.label}>
                  <div className="typography-extra-large-body font-medium text-grey-800">
                    {step.label}
                  </div>
                  <p className="typography-large-body-light text-grey-500 mt-1">
                    {step.note}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <p
            className="typography-large-body-light text-grey-500 mt-4"
            dangerouslySetInnerHTML={{
              __html: cancellationPolicy || "",
            }}
          ></p>

          {/* Payment Policy */}
          <h3 className="typography-sub-h1-regular font-medium text-grey-800 mt-8 mb-5">
            Payment policy
          </h3>

          <div className="flex flex-row gap-3 lg:hidden">
            <div className="flex flex-col sm:flex-row md:flex-col gap-6 items-start">
              <ProgressBar count={paymentSteps.length} />
            </div>

            <div className="flex flex-col sm:flex-row md:flex-col gap-6 items-start pt-10">
              <div className="flex-1 flex flex-col gap-10">
                {paymentSteps.map((step) => (
                  <div key={step.label}>
                    <div className="typography-extra-large-body font-medium text-grey-800">
                      {step.label}
                    </div>
                    <p className="typography-large-body-light text-grey-500 mt-1">
                      {step.note}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="hidden lg:block">
            <ProgressBar count={paymentSteps.length} />

            <div className="flex-1 flex flex-row justify-between gap-4">
              {paymentSteps.map((step) => (
                <div key={step.label}>
                  <div className="typography-extra-large-body font-medium text-grey-800">
                    {step.label}
                  </div>
                  <p className="typography-large-body-light text-grey-500 mt-1">
                    {step.note}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <p
            className="typography-large-body-light text-grey-500 mt-4"
            dangerouslySetInnerHTML={{
              __html: paymentPolicy || "",
            }}
          ></p>

          {/* Terms & Conditions */}
          <h3 className="typography-sub-h1-regular font-medium text-grey-800 mt-8 mb-5">
            Terms & Conditions
          </h3>
          <p
            className="typography-large-body-light text-grey-500 my-6"
            dangerouslySetInnerHTML={{
              __html: termsAndConditions || "",
            }}
          ></p>
          {/* <ul className="typography-large-body-light text-grey-500 pl-5 mt-1 list-disc list-inside mb-10">
            <li>
              The above cancellation policy is applicable per person basis.
            </li>
            <li>
              In case of group booking, the cancellation policy will be
              different and will be informed at the time of booking.
            </li>
            <li>
              The cancellation policy may vary during peak seasons and special
              events.
            </li>
          </ul> */}
        </div>
      )}
    </section>
  );
};

export default CancellationPolicy;
